import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
// import { getOurCulturePhotos} from "../actions";
import {
  getJobListingApi,
  getJobCountsApi,
  getJobListingResultApi,
  getCandidateCountsApi,
} from "../../API/API";

function* getJobListingSaga(params) {
  try {
    const response = yield call(() => getJobListingApi(params)); // API Backend
    if (response.status == 200) {
      yield put({
        type: types.GET_JOB_LISTING_SUCCESS,
        payload: response.data,
      });
      return;
    }
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_JOB_LISTING_FAILURE, error });
  }
}

function* getJobListingResultSaga(params) {
  try {
    const response = yield call(() => getJobListingResultApi(params)); // API Backend
    if (response.status == 200) {
      yield put({
        type: types.GET_JOB_RESULT_LISTING_SUCCESS,
        payload: response.data,
      });
      return;
    }
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_JOB_RESULT_LISTING_FAILURE, error });
  }
}

function* getJobCountsSaga(params) {
  try {
    const response = yield call(() => getJobCountsApi(params)); // API Backend
    if (response.status == 200) {
      yield put({ type: types.GET_JOB_COUNTS_SUCCESS, payload: response.data });
      return;
    }
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_JOB_COUNTS_FAILURE, error });
  }
}
function* getCandidateCountsSaga(params) {
  try {
    const response = yield call(() => getCandidateCountsApi(params)); // API Backend
    if (response.status == 200) {
      yield put({
        type: types.GET_CANDIDATE_COUNTS_SUCCESS,
        payload: response?.data?.result || [],
      });
      return;
    }
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_CANDIDATE_COUNTS_FAILURE, error });
  }
}

export function* watchGetJobListing() {
  yield takeEvery(types.GET_JOB_LISTING, getJobListingSaga);
}

export function* watchGetJobListingResult() {
  yield takeEvery(types.GET_JOB_RESULT_LISTING, getJobListingResultSaga);
}

export function* watchGetJobCounts() {
  yield takeEvery(types.GET_JOB_COUNTS_REQUESTED, getJobCountsSaga);
}

export function* watchGetCandidateCounts() {
  yield takeEvery(types.GET_CANDIDATE_COUNTS_REQUESTED, getCandidateCountsSaga);
}